import React from 'react'
import PropTypes from 'prop-types'
import { Fields } from '../components'

export default class FormRenderer extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    schema: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
  }

  state = {
    values: {},
  }

  constructor(props) {
    super(props)
  }

  onSubmit = () => {
    this.props.onSubmit({
      success: true,
      values: this.state.values,
    })
  }

  onChange({ event, name, value }) {
    this.setState(
      oldState => {
        return {
          values: { ...oldState.values, [name]: value },
        }
      },
      () => this.props.onChange({ event, name, value }),
    )
  }

  renderField = ({ name, type, ...props }) => {
    const Component = Fields[type]
    if (Component) {
      return (
        <Component
          key={name}
          {...props}
          onChange={(event, value) => {
            this.onChange({ event, name, value })
          }}
        />
      )
    }
  }
  render() {
    const { schema } = this.props
    return (
      <div>
        {schema.fields.map(field => this.renderField(field))}
        <button onClick={this.onSubmit}>next</button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/FormRenderer.js